import { Component, Input } from '@angular/core';
import { Terminal } from '../../../../../../@core/domain/interfaces/terminal.interface';

@Component({
  selector: 'app-terminal-screen',
  templateUrl: './terminal-screen.component.html',
  styleUrls: ['./terminal-screen.component.scss'],
})
export class TerminalScreenComponent {
  @Input()
  terminal!: Terminal;

  constructor() {}
}
